import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const reports = async () => axios.get(Routes.REPORTS);

export const useReports = () =>
  useQuery({
    queryKey: [Keys.REPORTS_QRY],
    queryFn: reports,
  });
